<header class="course-header">
    <div>
      <h1 class="course-header__title">{{ title() }}</h1>
    </div>
    @if (tasksProgress(); as progress) {
      <div class="course-header__progress">
        <span>{{ progress.completed }}/{{ progress.total }} {{ 'app.components.courseDetail.lessons' | translate }}</span>
      </div>
    }
    @if (rating()) {
      <div class="course-header__rating">
        <img src="/public/svgs/rating.svg" alt="Rating">
        <span>{{ rating() }}</span>
      </div>
    }
    @if (completionPercent() != null) {
      <div class="course-header__completion">
        <span>{{ completionPercent() }}%</span>
      </div>
    }
  </header>